module.exports = __webpack_public_path__ + "img/eductor_driving.1c9d5a67.svg";